import { useTranslation as e } from "../../i18n.mjs";
import { FieldFeedback as t } from "../field-feedback/index.mjs";
import { Button as n, ConfirmationDialog as r } from "@systemeio/components";
import { useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/confirmation-modal/index.tsx
function c({ opened: c, onClose: l, onConfirm: u, onDecline: d, title: f, confirmationText: p = "", cancelButtonCaption: m, confirmButtonCaption: h, confirmationContent: g, afterLeave: _, status: v = "normal" }) {
	let { t: y } = e(), [b, x] = i(""), [S, C] = i(!1), [w, T] = i(!1), E = async () => {
		try {
			C(!0), await u(), C(!1), T(!0);
		} catch {
			C(!1), x(y("file_manager.something_went_wrong"));
		}
	}, D = () => {
		x(""), T(!1);
	};
	return /* @__PURE__ */ o(r.Root, {
		open: c,
		onOpenChange: (e, t) => {
			if (!e) {
				if (S) {
					t.cancel();
					return;
				}
				!w && d && d(), l();
			}
		},
		onOpenChangeComplete: (e) => {
			e || (_?.(), D());
		},
		children: /* @__PURE__ */ o(r.Popup, {
			actions: /* @__PURE__ */ s(a, { children: [/* @__PURE__ */ o(r.Close, {
				render: /* @__PURE__ */ o(n, {
					disabled: S,
					type: "button",
					variant: "secondary"
				}),
				children: m || y("file_manager.cancel")
			}), /* @__PURE__ */ o(n, {
				isLoading: S,
				type: "submit",
				variant: v === "error" ? "destructive" : "primary",
				children: h || y("file_manager.confirm")
			})] }),
			closeProps: { disabled: S },
			description: p,
			feedback: /* @__PURE__ */ o(t, {
				error: b,
				errorClassName: "text-center"
			}),
			render: /* @__PURE__ */ o("form", { onSubmit: async (e) => {
				e.preventDefault(), await E();
			} }),
			status: v,
			title: f || y("file_manager.confirm_action"),
			children: g
		})
	});
}
//#endregion
export { c as ConfirmationModal };
